import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {MetricTileComponent} from '../../../metric-tile/metric-tile.component';
import {ScoreBarComponent} from '../../../score-bar/score-bar.component';
import {IndividualSubCriteriaScore} from '../../rfi-individual-results-modal.types';

@Component({
  selector: 'app-rfi-score-summary-cards',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, TranslocoPipe, MetricTileComponent, ScoreBarComponent],
  templateUrl: './rfi-score-summary-cards.component.html',
})
export class RfiScoreSummaryCardsComponent {
  readonly scores = input.required<IndividualSubCriteriaScore[]>();
}
